import React from "react";

export function TextField({ label, value, onChange, testid, placeholder = "", type = "text" }) {
  return (
    <label className="block">
      {label && (
        <span className="block text-xs font-semibold tracking-[0.1em] uppercase text-stone-500 mb-2">
          {label}
        </span>
      )}
      <input
        type={type}
        value={value ?? ""}
        placeholder={placeholder}
        data-testid={testid}
        onChange={(e) => onChange(e.target.value)}
        className="w-full rounded-md border border-stone-300 bg-white px-3 py-2.5 text-sm text-stone-800 focus:outline-none focus:ring-2 focus:ring-stone-950 transition-shadow"
      />
    </label>
  );
}

export function TextArea({ label, value, onChange, testid, placeholder = "", rows = 4 }) {
  return (
    <label className="block">
      {label && (
        <span className="block text-xs font-semibold tracking-[0.1em] uppercase text-stone-500 mb-2">
          {label}
        </span>
      )}
      <textarea
        rows={rows}
        value={value ?? ""}
        placeholder={placeholder}
        data-testid={testid}
        onChange={(e) => onChange(e.target.value)}
        className="w-full rounded-md border border-stone-300 bg-white px-3 py-2.5 text-sm text-stone-800 focus:outline-none focus:ring-2 focus:ring-stone-950 transition-shadow resize-y"
      />
    </label>
  );
}

export function Panel({ title, description, children }) {
  return (
    <div className="rounded-lg border border-stone-200 bg-white shadow-sm p-6 md:p-8">
      <div className="mb-6">
        <h3 className="font-semibold text-lg text-stone-900">{title}</h3>
        {description && <p className="text-sm text-stone-500 mt-1">{description}</p>}
      </div>
      <div className="space-y-5">{children}</div>
    </div>
  );
}
